import React, { ChangeEvent, ReactNode, useEffect, useState } from "react";


interface ButtonProps {
    text?: string;
    textColor?: string;
    border?: string;
    onClick?: (any: any) => any;
    color?: string;
    colorHover?: string;
    children?: ReactNode | undefined;
    className?: string;
    disabled?: boolean
    type?: "button" | "reset" | "submit"
    kind?: "normal" | "outline",
    schema?: "success" | "warning" | "info" | "danger" | "normal"
}

interface ColorSchema {
    font: string;
    border: string;
    background: string;
}
export const CoreButton = ({
    text,
    color,
    children,
    className,
    disabled,
    type = "button",
    kind = "normal",
    schema = "normal",
    onClick,


}: ButtonProps) => {


    const getColorBorder = (): string => {
        return "";
        if (disabled) {
            switch (schema) {
                case "normal": return kind === "normal" ? "" : "border-2 border-gray-200";
                case "success": return kind === "normal" ? "" : "border-2 border-green-200";
                case "info": return kind === "normal" ? "" : "border-2 border-blue-200";
                case "warning": return kind === "normal" ? "" : "border-2 border-amber-200";
                case "danger": return kind === "normal" ? "" : "border-2 border-red-200";
            }
        }
        switch (schema) {
            case "normal": return kind === "normal" ? "" : "border-2 border-gray-200";
            case "success": return kind === "normal" ? "" : "border-2 border-green-500";
            case "info": return kind === "normal" ? "" : "border-2 border-blue-500";
            case "warning": return kind === "normal" ? "" : "border-2 border-amber-500";
            case "danger": return kind === "normal" ? "" : "border-2 border-red-500";
        }
    }
    const getFontColor = (): string => {
        if (disabled) {
            return "text-gray-500";

        }
        switch (schema) {
            case "normal": return kind === "normal" ? "text-white" : "text-gray-500";
            case "success": return kind === "normal" ? "text-white" : "text-green-500";
            case "info": return kind === "normal" ? "text-white" : "text-blue-500";
            case "warning": return kind === "normal" ? "text-white" : "text-amber-500";
            case "danger": return kind === "normal" ? "text-white" : "text-red-500";
        }
    }



    const getBgColor = (): string => {
        if (disabled) {
            return "bg-gray-50";

        }
        switch (schema) {
            case "normal": return kind === "normal" ? "bg-gray-500 hover:bg-gray-700" : "hover:bg-gray-100";
            case "success": return kind === "normal" ? "bg-green-500 hover:bg-green-700" : "hover:bg-green-100";
            case "info": return kind === "normal" ? "bg-blue-500 hover:bg-blue-700" : "hover:bg-blue-100";
            case "warning": return kind === "normal" ? "bg-amber-500 hover:bg-amber-700" : "hover:bg-amber-100";
            case "danger": return kind === "normal" ? "bg-red-500 hover:bg-red-700" : "hover:bg-red-100";
        }
    }

    let colorSchema = {
        border: getColorBorder(),
        font: getFontColor(),
        background: getBgColor()
    }

    return <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`${className} shadow-sm w-full px-4  h-10 uppercase rounded-md text-xs font-bold ${colorSchema.background} ${colorSchema.font} ${colorSchema.border}    `}>{text}
        {children}
    </button>
}